import {Action} from '@reduxjs/toolkit'
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  SetFilter: '[Allocation SetFilter] Action',
  ResetFilter: '[Allocation ResetFilter] Action',
}

const initialAllocationState: IAllocationState = {
  filter: {
    status: '',
    active: true,
  },
}

export interface IAllocationState {
  filter?: {
    status: string
    active: boolean
  }
}

export const reducer = persistReducer(
  {storage, key: 'v100-Allocation', whitelist: ['filter']},
  (
    state: IAllocationState = initialAllocationState,
    action: ActionWithPayload<IAllocationState>
  ) => {
    switch (action.type) {
      case actionTypes.ResetFilter: {
        return initialAllocationState
      }

      case actionTypes.SetFilter: {
        const filter = action.payload?.filter
        return {...state, filter}
      }

      default:
        return state
    }
  }
)

export const Actions = {
  resetFilter: () => ({type: actionTypes.ResetFilter}),
  setFilter: (filter: object) => ({
    type: actionTypes.SetFilter,
    payload: {filter},
  }),
}

export function* saga() {}
